'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MozartModal = require('./MozartModal/MozartModal');

var _MozartModal2 = _interopRequireDefault(_MozartModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MozartDialog = function (_Component) {
  _inherits(MozartDialog, _Component);

  function MozartDialog(props) {
    _classCallCheck(this, MozartDialog);

    var _this = _possibleConstructorReturn(this, (MozartDialog.__proto__ || Object.getPrototypeOf(MozartDialog)).call(this, props));

    _this.state = { isOpen: false };
    return _this;
  }

  _createClass(MozartDialog, [{
    key: 'toggleModal',
    value: function toggleModal() {
      var _this2 = this;

      this.setState({
        isOpen: !this.state.isOpen
      }, function () {
        if (_this2.state.isOpen && _this2.props.handleClose) {
          _this2.props.handleClose();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          id = _props.id,
          title = _props.title,
          disableSubmit = _props.disableSubmit,
          node = _props.node,
          contentNode = _props.contentNode,
          submitLabel = _props.submitLabel,
          width = _props.width,
          themeId = _props.themeId;

      return _react2.default.createElement(
        'div',
        { 'data-theme': themeId },
        _react2.default.createElement(
          'div',
          { style: { cursor: 'pointer' }, onClick: this.toggleModal.bind(this) },
          node
        ),
        _react2.default.createElement(
          _MozartModal2.default,
          {
            id: id,
            show: this.state.isOpen,
            onClose: this.toggleModal.bind(this),
            title: title,
            submitLabel: submitLabel,
            handleSubmit: function handleSubmit() {
              _this3.setState({
                isOpen: false
              }, function () {
                _this3.props.handleSubmit();
              });
            },
            width: width,
            disableSubmit: disableSubmit
          },
          contentNode
        )
      );
    }
  }]);

  return MozartDialog;
}(_react.Component);

MozartDialog.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** id attribute */
  id: _propTypes2.default.string,
  /** title of the dialog */
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** node trigger modal */
  node: _propTypes2.default.node,
  /** custom width */
  width: _propTypes2.default.string,
  /** hide submit button */
  disableSubmit: _propTypes2.default.bool,
  /** content of modal */
  contentNode: _propTypes2.default.node,
  /** callback when submit clicked */
  handleSubmit: _propTypes2.default.func,
  /** callback when closed */
  handleClose: _propTypes2.default.func,
  /** submit button label */
  submitLabel: _propTypes2.default.string
};

MozartDialog.defaultProps = {
  testId: 'MozartDialog',
  themeId: 'MozartDialog'
};

exports.default = MozartDialog;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDialog/MozartDialog.js
// module id = 1958
// module chunks = 1